var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frameworkBox"},[_c('img',{attrs:{"src":require('@/assets/image/组织架构_05.png'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }